export default "__VITE_ASSET__BxLgT_wp__"